export default "__VITE_ASSET__Cy3MHcxH__"